/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Filters/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import LocationChooser from './LocationChooser/index'
import MedicalHistoryQuestions from './MedicalHistoryQuestions/index'
import React from 'react'
import StatusChooser from './StatusChooser/index'
import WidgetTypeChooser from './WidgetTypeChooser/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Filters({
  children,
  viewPath = "/App/Account/Content/PatientsList/Filters"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Filters.Horizontal"
  data-view-path={viewPath}
 style={{'--ml-1-Wv2Qg': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mr-2-Wv2Qg': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<LocationChooser
  viewPath={`${viewPath}/LocationChooser`}
/>
<WidgetTypeChooser
  viewPath={`${viewPath}/WidgetTypeChooser`}
/>
<StatusChooser
  viewPath={`${viewPath}/StatusChooser`}
/>
<MedicalHistoryQuestions
  viewPath={`${viewPath}/MedicalHistoryQuestions`}
/>
</div>
{children}
</React.Fragment>)
}